




import { Component, Prop, Vue } from "vue-property-decorator";

import ProductAllocationWorkspace from "./Workspace.vue";

import { ProductAllocationSlotTypeValue } from "../../product-allication-slot-type.value";

@Component({ components: { ProductAllocationWorkspace } })
export default class ProductAllocationViewForm extends Vue {
  @Prop({ required: true })
  public readonly slotType!: ProductAllocationSlotTypeValue;
}
